import { jsx as _jsx } from "react/jsx-runtime";
import Link from '../link';
const ButtonWrapper = ({ children, to }) => {
    if (to) {
        if (to === null || to === void 0 ? void 0 : to.includes('http')) {
            return (_jsx("a", { href: to, target: "_blank", rel: "noopener noreferrer", children: children }));
        }
        return _jsx(Link, { to: to, children: children });
    }
    return children;
};
export default ButtonWrapper;
